import BaseUrl from '../util/BaseUrl';

const API_URL = BaseUrl.baseUrl;

const getPlanImage = API_URL+'image/plansimage/';
const getAdsImage = API_URL+'image/adsimage/';
const getInvoiceImage = API_URL+'image/bills/';

const imageService ={
 getPlanImage,
 getAdsImage,
 getInvoiceImage

};

export default imageService